import { environment } from "src/variables";
// Components
import Header from "src/app/components/Header";
import Form from "src/app/components/Form";

import locations from "src/app/assets/service_locations.jpg";
import backgroundImage from "src/app/assets/background.jpg";
import CallIcon from "@material-ui/icons/Call";
import {
  createTheme,
  ThemeProvider,
  Typography,
  Card,
  CardMedia,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@material-ui/core";

// Styles
import { Wrapper, Spacer } from "src/app/App.styles";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#1ba0d7",
    },
    secondary: {
      main: "#a27c10",
    },
  },
});

const bannerText: any = {
  style: {
    fontFamily: "Georgia, serif",
    background: "linear-gradient(#1ba0d7, #a27c10)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    fontSize: "50px",
  },
};

const unavailable: any = {
  style: {
    fontFamily: "Georgia, serif",
    background: "#d71b1b",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    fontSize: "50px",
  },
};

const headerText: any = {
  style: {
    fontFamily: "Georgia, serif",
    fontSize: "36px",
  },
};

const floatLeft: any = {
  style: {
    textAlign: "start",
    minWidth: "715px",
    fontFamily: "Georgia, serif",
    fontSize: "36px",
  },
};

const ride: string =
  "All ride requests must be payed prior to a driver being dispatched via cash app Venmo PayPal or bank transfer if you plan to pay cash please be aware failure to pay before getting into the vehicle will result in a $5 fee that must be payed before any future rides are given ( this is only applicable in refusal to pay or an attempt to make changes to the payment option you have indicated when requesting the ride)<br /><br />" +
  "Additional stops along the route are $5 unless located in opposite direction from the original route. (Example 1 if your ride request is from Hildale to Centaniel Park and your extra stop is in Colorado city the $5 fee applies) (example 2 if your ride request is from Hildale to Centaniel Park and an additional stop is requested in apple valley the extra fee is $15)<br ><br >" +
  "Fees are determined based on the original pickup point please be careful when selecting a pickup address as it effects the pricing of the service<br /><br />" +
  "Stops allow for a 10 min wait time and an additional $5 for every 10 minutes exceeding the original.<br /><br />" +
  "Any damages the rider may cause during the trip will be billed with an estimate provided from the place of repair.<br /><br />" +
  "For any puke vomit or any cleaning that has to be done with the exception of a vacuum and general trash will result in a $100 cleaning fee to have the vehicle detailed and shampooed.<br /><br />" +
  "Failure to pay any balances after a ride will result in not accepting your ride requests until the balance is paid in full.<br /><br />" +
  "Riders cannot have any weapons of any kind with them in the vehicle if found with a weapon the rider will not be able to request future rides.<br /><br />" +
  "Please be aware we have a max capacity of 3 people per ride the flat rate fee covers the pickup of yourself and 2 others at the place of pickup.<br /><br />" +
  "No rider under the age of 18 may request a ride unless accompanied by an adult during the trip if your driver suspects the passenger may be under 18 the rider must provide identification upon the request to prove their age." +
  "Any and all personal items and belongings left in the vehicle will be returned to the business address of 380 W harker ave and retrieval of items needs to be arranged with the company prior to arriving at the company address by calling 928-218-0352 left items may not be available for immediate retrieval please remember to work patiently with staff to coordinate the return in the fastest possible way.";

const rules: string =
  "No hazardous material, alcohol, or tobacco. " +
  "Items may not exceed 3 feet in length. " +
  "We do not handle any portion of the sale, please ensure the items are available for pickup.";

const cites: any = [
  { value: "Apple Valley", state: "UT", zip: 84737 },
  { value: "Cane Beds", state: "AZ", zip: 86021 },
  { value: "Centennial Park", state: "AZ", zip: 86021 },
  { value: "Colorado City", state: "AZ", zip: 86021 },
  { value: "Hildale", state: "UT", zip: 84784 },
  { value: "Hurricane", state: "UT", zip: 84737 },
  { value: "Kanab", state: "UT", zip: 84741 },
  { value: "St George", state: "UT", zip: "Please enter you zip in the Special instructions below" }, // [84770, 84771, 84790, 84791]
  { value: "Toqorville", state: "UT", zip: 84774 },
  { value: "Washington", state: "UT", zip: 84780 },
];

const pickup: any = {
  type: "sub-form",
  label: "Place of pickup",
  action: {
    key: "pickup_add",
    label: "Add",
    type: "button",
  },
  address: { label: "Address", type: "text", required: true },
  city: { label: "City", type: "select", options: cites, required: true },
  state: { label: "State", type: "label", path: ["pickup", "city", "value", "state"] },
  zip: { label: "Zip", type: "label", path: ["pickup", "city", "value", "zip"] },
};

const drop: any = {
  type: "sub-form",
  label: "Place of drop-off",
  action: {
    key: "drop-off_add",
    label: "Add",
    type: "button",
  },
  name: { type: "hidden" },
  phone: { type: "hidden" },
  address: { label: "Address", type: "text", required: true },
  city: { label: "City", type: "select", options: cites, required: true },
  state: { label: "State", type: "label", path: ["drop", "city", "value", "state"] },
  zip: { label: "Zip", type: "label", path: ["drop", "city", "value", "zip"] },
};

const company: any = {
  fields: {
    type: "overrides",
    "+1 (435) 429-3899": {
      name: "Dev Mathew Berg",
      email: "cybeffects@gmail.com",
      pickup: {
        address: "",
        city: cites,
        state: pickup.state,
        zip: pickup.zip,
      },
      drop: {
        address: "2425 S 2100 E",
        city: cites[1],
        state: "AZ",
        zip: 86021,
      },
    },
    "+1 (435) 215-2980": {
      label: "Business name",
      name: "Red Brick Take n Bake Pizza",
      pickup: {
        address: "385 Township Ave",
        city: cites[3],
        state: "AZ",
        zip: 86021,
      },
      drop: {
        name: { id: "drop_name", label: "Drop-off Customer", type: "text", required: false },
        phone: {
          id: "drop_phone",
          label: "Drop-off Phone",
          type: "tel",
          minLength: 10,
          maxLength: 10,
          required: false,
        },
        address: { value: "36.94696° N, 112.95568° W", type: "hidden" },
        city: cites,
        state: drop.state,
        zip: drop.zip,
      },
    },
    // "+1 (928) 875-2299": {
    //   label: "Business name",
    //   name: "Blue Agave Mexican Kitchen",
    //   pickup: {
    //     address: "390 Arizona Ave",
    //     city: cites[3],
    //     state: "AZ",
    //     zip: 86021,
    //   },
    //   drop: {
    //     name: { id: "drop_name", label: "Drop-off Customer", type: "text", required: false },
    //     phone: {
    //       id: "drop_phone",
    //       label: "Drop-off Phone",
    //       type: "tel",
    //       minLength: 10,
    //       maxLength: 10,
    //       required: false,
    //     },
    //     address: { value: "36.94696° N, 112.95568° W", type: "hidden" },
    //     city: cites,
    //     state: drop.state,
    //     zip: drop.zip,
    //   },
    // },
  },
  ids: ["+1 (435) 429-3899", "+1 (435) 215-2980"],
};

const formFields: any = {
  companies: company.fields,
  name: { label: "Customer name", type: "text", required: true },
  phone: {
    label: "Phone number",
    type: "tel",
    companyIds: company.ids,
    required: true,
    minLength: 10,
    maxLength: 10,
  },
  email: { label: "Email", type: "email", required: false },
  pickup: pickup,
  drop: drop,
  message: {
    label: "Special instructions",
    type: "text-field",
    required: false,
    maxLength: 250,
  },
};

function createData(location: string, price: number) {
  return { location, price };
}

const rows = [
  createData("Blue Agave", 9),
  createData("Local", 20),
  createData("Hurricane (UT)", 50),
  createData("St George (UT)", 100),
];

const rides = [
  createData("Pickup and drop off from Colorado City and Hildale", 10),
  createData("Pickup from Hildale or Colorado City and drop off to Centaniel Park", 15),
  createData("Pickup from Hildale or Colorado City and drop off to Cane Beds", 20),
  createData("Pickup from Cane Beds and drop off to Apple Valley", 30),
  createData("Pickup from Hildale and drop off to Apple Valley", 25),
  createData("Pickup from Colorado City and drop off to Apple Valley", 20),
  createData("Pickup from Centaniel Park and drop off to Cane Beds", 15),
];

export default function Home() {
  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      background: {
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundImage: `url(${backgroundImage})`,
      },
      foreground: {
        minWidth: "100%",
        minHeight: "100%",
      },
      locations: {
        width: "90%",
        maxWidth: "728px",
        height: "45vw",
        maxHeight: "380px",
        display: "flex",
        justifyContent: "center",
        backgroundSize: "100% auto",
        backgroundPosition: "center",
        background: "no-repeat",
        backgroundImage: `url(${locations})`,
      },
      table: {
        maxWidth: 725,
      },
      rideContainer: {
        display: "flex",
        flexWrap: "nowrap",
        gap: "1rem",
        maxWidth: "723px",
        height: "400px",
      },
      ride: {
        textAlign: "start",
        overflowX: "auto",
        padding: "0 10px",
        fontFamily: "Georgia, serif",
        scrollSnapType: "x mandatory",
      },
      rules: {
        textAlign: "center",
        maxWidth: "715px",
        fontFamily: "Georgia, serif",
      },
      form: {
        color: "#ffffff",
      },
    }),
  );
  const classes = useStyles();
  return (
    <ThemeProvider theme={theme}>
      <div className={classes.background}>
        <section className={classes.foreground}>
          <Wrapper>
            <Header text={environment.siteTitle} style={bannerText.style} divider={true} />
          </Wrapper>
          <Spacer height={32} />
          <Wrapper>
            <Header text="Service Locations" style={headerText.style} />
            <div className={classes.locations} title="Service Map" />
          </Wrapper>
          <Spacer height={32} />
          <Wrapper>
            <Header text="Location Pricing" style={headerText.style} />
            <TableContainer className={classes.table} component={Paper}>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>Service Location</TableCell>
                    <TableCell align="right">Price</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows.map((row) => (
                    <TableRow key={row.location}>
                      <TableCell component="th" scope="row">
                        {row.location}
                      </TableCell>
                      <TableCell align="right">{"$" + row.price}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Wrapper>
          <Spacer height={32} />
          <Wrapper>
            <Header text="Ride Service" style={headerText.style} />
            <TableContainer className={classes.table} component={Paper}>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>Ride Locations</TableCell>
                    <TableCell align="right">Price</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rides.map((row) => (
                    <TableRow key={row.location}>
                      <TableCell component="th" scope="row">
                        {row.location}
                      </TableCell>
                      <TableCell align="right">{"$" + row.price}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Wrapper>
          <Spacer height={32} />
          <Wrapper>
            <Header text="Ride Service Agreement" style={headerText.style} />
            <Card className={classes.rideContainer}>
              <Typography className={classes.ride} dangerouslySetInnerHTML={{ __html: ride }} />
            </Card>
          </Wrapper>
          <Spacer height={32} />
          <Wrapper>
            <Header text="Rules & Restrictions" style={headerText.style} />
            <Card>
              <Typography className={classes.rules}>{rules}</Typography>
            </Card>
          </Wrapper>
          <Spacer height={32} />
          <Form className={classes.form} formFields={formFields} urlRequest="/public/delivery/request" />
          <Spacer height={32} />
          <Wrapper>
            <CallIcon />
            <Card>
              <Typography>
                <a href="tel:+19282180352">(928) 218-0352</a>
              </Typography>
            </Card>
          </Wrapper>
        </section>
      </div>
    </ThemeProvider>
  );
}
